import { createModel } from '@rematch/core';
import {
  NetworkMember,
  PartialMember,
  UpdateNetworkMember,
} from 'domains/networkDomain';
import type { RootModel } from 'models';
import { baseReducers, BaseState } from 'models/baseReducers';
import networkService from 'services/networkService';

interface NetworkState extends BaseState {
  members: NetworkMember[];
  pageSize: number;
  searchValue: string;
  currentPage: number;
  isMember: boolean;
  marketplaceNetworksForOrgId?: number;
}

export const network = createModel<RootModel>()({
  state: {
    members: [],
    searchValue: '',
    pageSize: 20,
    currentPage: 1,
    isMember: false,
  } as NetworkState,
  reducers: {
    ...baseReducers<NetworkState>(),
    reset: (state: NetworkState) => {
      state.members = [];
      return state;
    },
  },
  effects: (dispatch) => {
    const { network } = dispatch;
    return {
      async getNetworksByMemberId({
        networkId = 1,
      }: {
        networkId?: number;
      }): Promise<void> {
        try {
          const members = await networkService.getNetworksByMemberId(networkId);
          network.setState({
            members: members,
          });
        } catch (e) {
          network.setState({
            members: [],
          });
        }
      },

      async addMembers({
        networkId = 1,
        memberIds,
      }: {
        networkId?: number;
        memberIds: number[];
      }): Promise<void> {
        const requests = memberIds.map((memberId) => {
          return networkService.addMember({
            networkId,
            memberId: memberId,
          });
        });

        await Promise.all(requests);
      },

      async addMemeber(member: PartialMember): Promise<void> {
        await networkService.addMember(member);
      },

      async updateMember(member: UpdateNetworkMember): Promise<void> {
        await networkService.updateMember(member);
      },

      async deleteMember(member: PartialMember): Promise<void> {
        await networkService.deleteMember(member);
      },

      async getIsMember(networkId: number): Promise<void> {
        const isMember = await networkService.getIsMember(networkId);
        network.setState({
          isMember,
        });
      },
    };
  },
});
